const userStore = {
  state: {
    name: null,
    id: null,
    bgImgClass: '',
  },
  formatPassengerName(passenger) {
    let name = '';
    if (passenger) {
      if (this.state.name === 'amigo') {
        if (passenger.nickname) {
          name = `${passenger.nickname}`;
        } else if (passenger.firstname) {
          name = `${passenger.firstname}`;
        }
      } else {
        if (passenger.middlename) {
          name = `${name} ${passenger.middlename}`;
        }
        if (passenger.lastname) {
          name = `${name} ${passenger.lastname}`;
        }
      }
    }
    return name;
  },
  getFirstname(passenger) {
    let name = '';

    if (passenger) {
      if (passenger.nickname) {
        name = `${passenger.nickname}`;
      } else if (passenger.firstname) {
        name = `${passenger.firstname}`;
      }
    }
    return name;
  },
  getGenderPrefix(passenger) {
    let prefix = 'mevrouw';
    if (passenger.gender === 'male') {
      prefix = 'heer';
    }
    return prefix;
  },
  formatPassengerNameLong(passenger) {
    let name = '';
    if (passenger) {
      if (this.state.name === 'amigo') {
        if (passenger.nickname) {
          if (passenger.nickname) {
            name = `${passenger.nickname}`;
          }
        } else if (passenger.firstname) {
          name = `${passenger.firstname}`;
        }
        if (passenger.middlename) {
          name = `${name} ${passenger.middlename}`;
        }
        if (passenger.lastname) {
          name = `${name} ${passenger.lastname}`;
        }
      } else {
        if (passenger.initials) {
          name = `${passenger.initials}`;
        }
        if (passenger.middlename) {
          name = `${name} ${passenger.middlename}`;
        }
        if (passenger.lastname) {
          name = `${name} ${passenger.lastname}`;
        }
      }
    }
    return name;
  },
};

export default userStore;



// WEBPACK FOOTER //
// ./src/store/entityStore.js